module.exports = "<pre><code class=\"hljs js\"><span class=hljs-keyword>import</span> Vue <span class=hljs-keyword>from</span> <span class=hljs-string>'vue'</span>\n<span class=hljs-keyword>import</span> * <span class=hljs-keyword>as</span> Dialog <span class=hljs-keyword>from</span> <span class=hljs-string>'wovue-dialog'</span>\n\nVue.component(<span class=hljs-string>'modal'</span>, Dialog.component)\nVue.directive(<span class=hljs-string>'modal'</span>, Dialog.directive)\n</code></pre> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src-docs/app/snippets/installation-commonjs-alternative2.md
 ** module id = 116
 ** module chunks = 1
 **/